export default __webpack_public_path__ + "static/media/pk-sd.76ebe2a5.svg";